import { SectionCard } from "#src/commonV2/SectionCard";
import { useTranslation } from "react-i18next";
import { ICustomerInfoRenderProps } from "./types";
import { FormInput } from "#src/commonV2/form/Input/FormInput";
import { FormDropdown } from "#src/commonV2/form/Dropdown/FormDropdown";

interface IPaymentEnterInformationCustomerInfoProps {
  customerInfoRenderProps: ICustomerInfoRenderProps;
}

export const PaymentEnterInformationCustomerInfo = ({
  customerInfoRenderProps,
}: IPaymentEnterInformationCustomerInfoProps) => {
  const { t } = useTranslation("common", {
    keyPrefix: "v2.payment.enterInformation.customerInformation",
  });

  // --------------- METHODS ---------------

  // --------------- RENDER ---------------

  return (
    <SectionCard header={t("title")}>
      <div className="p-4 grid grid-cols-2 gap-x-6 gap-y-3 rounded-xl bg-white border border-gray-v2-200">
        <FormInput {...customerInfoRenderProps.fullName} />
        <FormInput {...customerInfoRenderProps.phoneNumber} />
        <FormDropdown {...customerInfoRenderProps.jobTitle} />
        <FormInput {...customerInfoRenderProps.email} />
      </div>
    </SectionCard>
  );
};
